import { PURGE } from "redux-persist";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AuthState {
  refreshToken?: string | null;
  accessToken?: string | null;
  hasLoggedIn?: boolean;
}

const initialState: AuthState = {
  refreshToken: null,
  accessToken: null,
  hasLoggedIn: false
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<AuthState>) => {
      return {
        ...state,
        ...action.payload
      };
    },
    resetAuth: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

export const { setAuth, resetAuth } = authSlice.actions;
export const authReducer = authSlice.reducer;
